
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competitions",
      function () {
        return require("private-next-pages/competitions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competitions"])
      });
    }
  